import Vue from 'vue';
import App from './App';
import { router } from './router';
import store from './store/index'
import compUtil from './util/compoents'
import dateTimeUtil from './util/dateTimeUtil'

import CommonComponents from './components/commonComponents/index'
import BussComponents from './view/bussComponents/index'
import sysUtil from './util/sysUtil'
import Bus from './util/eventBus'
import Print from 'vue-print-nb'

Vue.use(Print)
Vue.prototype.$baseURL = process.env.VUE_APP_BASE_API

Vue.prototype.$timeOut = 3600000
Vue.prototype.$isDebug = process.env.ISDEBUG
Vue.prototype.$curDomain = window.$config.curDomain;
Vue.prototype.$appId = window.$config.appId;
Vue.prototype.$isDebug = window.$config.isDebug;
Vue.prototype.$compUtil = compUtil;
Vue.prototype.$dateTimeUtil = dateTimeUtil
Vue.prototype.$sysUtil = sysUtil
Vue.prototype.$bus = Bus

import { 
  Tabbar,TabbarItem,Icon,Button,Col,Toast,Dialog,Row,Grid, GridItem,NavBar,Picker,
  Form ,Field ,SubmitBar,DatetimePicker,Search ,ContactList,List ,CellGroup,Popup,Cell,
  RadioGroup, Radio,Tag,Divider ,Collapse, CollapseItem,Empty,Progress 
} from 'vant';
import { Image as VanImage } from 'vant';

Vue.use(VanImage);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Icon);
Vue.use(Button);
Vue.use(Col);
Vue.use(Dialog);
Vue.use(Row);
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(NavBar)
Vue.use(Form);
Vue.use(Field);
Vue.use(SubmitBar);
Vue.use(Picker);
Vue.use(DatetimePicker);
Vue.use(Search);
Vue.use(ContactList);
Vue.use(List);
Vue.use(Toast);
Vue.use(CellGroup)
Vue.use(Popup);
Vue.use(Cell);
Vue.use(CommonComponents);
Vue.use(Tag);
Vue.use(Divider)
Vue.use(Empty)
Vue.use(Progress)
Vue.use(BussComponents)

Toast.setDefaultOptions({ duration: 5000 });

new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App),
  components:{
    Tabbar, 
    TabbarItem,
    Icon,
    Button,
    Col,
    Toast,
    Dialog,
    Row,
    Grid,
    GridItem,
    NavBar,
    Form,
    Field,
    SubmitBar,
    Picker,
    Search,
    ContactList,
    List,
    Cell,
    VanImage,
    CellGroup,
    Popup,
    RadioGroup, 
    Radio,
    Tag,
    Divider,
    CommonComponents,
    Collapse,
    CollapseItem,
    Empty,
    Progress
  },
  async mounted(){
  }
});


